import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
export const organizationDatasourceData = createCrudVuexModule({
  namespaced: true,
  path: "/datasource-data",
  options: { localizedFields: ["name", "description", "note"] },
  actions: {
    async save({ dispatch }, { payload, changeInAllHierarchy }) {
      if (payload._id) {
        return dispatch("update", { payload, changeInAllHierarchy });
      } else {
        return dispatch("create", payload);
      }
    },

    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post(`/datasource-data`, { item: payload });
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async update({ getters, commit, dispatch }, { payload, changeInAllHierarchy }) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put(`/datasource-data`, { item: payload, changeInAllHierarchy });

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/datasource-data/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async updateNote({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.put(`/datasource-data/note`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
